// The video editor's layers strings (components/Editor), under t('editor.rve.layers.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  common: {
    volume: "Volume",
    mute: "Mute",
    unmute: "Unmute",
  },
  tabs: {
    settings: "Settings",
    style: "Style",
    allCount: "All ({n})",
  },
  style: {
    appearance: "Appearance",
    fit: "Fit",
    fitCover: "Cover",
    fitContain: "Contain",
    fitFill: "Fill",
    borderRadius: "Border Radius",
    brightness: "Brightness",
    padding: "Padding",
    paddingBackground: "Padding Background",
    clear: "Clear",
  },
  filter: {
    preset: "Filter Preset",
    custom: "Custom",
    presetPreview: "{name} preview",
  },
  filterPresets: {
    none: "None",
    retro: "Retro",
    vintage: "Vintage",
    wesAnderson: "Wes Anderson",
    noir: "Film Noir",
    polaroid: "Polaroid",
    cinematic: "Cinematic",
    cool: "Cool",
    warm: "Warm",
    expired: "Expired Film",
    kodak: "Kodak",
    super8: "Super 8",
  },
  animation: {
    title: "Animations",
    enter: "Enter Animation",
    exit: "Exit Animation",
  },
  animations: {
    none: "None",
    fade: "Fade",
    slideRight: "Slide",
    scale: "Scale",
    bounce: "Bounce",
    flipX: "Flip",
    zoomBlur: "Zoom",
    slideUp: "Slide",
    snapRotate: "Snap",
    glitch: "Glitch",
    swipeReveal: "Swipe",
    floatIn: "Float",
  },
  image: {
    preview: "Image preview",
  },
  video: {
    preview: "Video preview",
    playbackSpeed: "Playback Speed",
    reset: "Reset",
    selectSpeed: "Select speed",
    speedNormal: "1x (Normal)",
    speedCustom: "{speed}x (Custom)",
  },
  pexels: {
    searchImages: "Search images...",
    searchVideos: "Search videos...",
    orientation: "Orientation",
    allOrientations: "All orientations",
    landscape: "Landscape",
    portrait: "Portrait",
    square: "Square",
    size: "Size",
    allSizes: "All sizes",
    small: "Small",
    medium: "Medium",
    large: "Large",
    imagesFound: "{n} images found",
    videosFound: "{n} videos found",
    page: "Page {n}",
    photoBy: "Photo by {name}",
    videoBy: "Video by {name}",
    unknown: "Unknown",
    by: "by {name}",
    noImagesFor: "No images found for \"{query}\"",
    noVideosFor: "No videos found for \"{query}\"",
    poweredBy: "Powered by",
    fetchErrorTitle: "Error fetching media",
    fetchErrorBody: "Failed to fetch media from Pexels. Please try again later.",
  },
  emptyState: {
    noneAvailable: "No {items} available",
    noResults: "No {items} found",
    noResultsIn: "No {items} found in {source}",
    tryAnother: "Try a different search term",
    useSearch: "Use the search to find {items}",
    enterTerm: "Enter a search term above",
    mediaTypes: {
      templates: "templates",
      videos: "videos",
      images: "images",
    },
  },
  localMedia: {
    savedUploads: "Saved Uploads",
    upload: "Upload",
    uploadMedia: "Upload Media",
    uploadFailed: "Failed to upload file. Please try again.",
    unsupportedType: "Unsupported file type",
    deleteMedia: "Delete media",
    all: "All",
    images: "Images",
    videos: "Videos",
    audio: "Audio",
    loading: "Loading media files...",
    emptyTitle: "No media files",
    emptyHint: "Upload your first media file to get started",
    addToTimeline: "Add to Timeline",
    fileTypes: {
      image: "image",
      video: "video",
      audio: "audio",
    },
  },
  sounds: {
    library: "Clip-Short music",
    moods: {
      suspense: "Suspense",
      epic: "Epic",
      uplifting: "Uplifting",
      calm: "Calm",
      playful: "Playful",
      emotional: "Emotional",
      tech: "Tech",
      lofi: "Lo-fi",
      oriental: "Oriental",
      dramatic: "Dramatic",
    },
    searchTab: "Sound effects",
    featuredTab: "Music",
    searchPlaceholder: "Search sound effects…",
    searching: "Searching sounds...",
    noResults: "No sounds found",
    searchPrompt: "Search for a sound effect",
    poweredBy: "Powered by Freesound.org",
    results: "{n} results",
    addToTimeline: "Add to timeline",
    loading: "Loading...",
    loadMore: "Load More",
    soundsFrom: "Sounds from",
    creativeCommons: "(Creative Commons)",
    musicHint: "Our own music, safe to post anywhere. Pick a mood, hear its tracks, and put one under your whole video: it plays quietly under the voice. Change its volume on the timeline.",
    putUnder: "Put under the video",
    useInstead: "Use this instead",
    underVideo: "Under this video: {mood}",
    removeMusic: "Remove",
    listen: "Listen to {mood}",
  },
  progressBar: {
    description: "Fills across the video as it plays, so viewers can see how much is left. It spans the layer’s time on the timeline.",
    colour: "Colour",
    colourSwatch: "Colour {color}",
    position: "Position",
    top: "top",
    bottom: "bottom",
    thickness: "Thickness",
    stretch: "Stretch over the whole video",
    add: "Progress bar",
    replace: "Replace the progress bar",
    addHint: "Shows how much of the video is left",
  },
};
